<div class="max-w-2xl mx-auto">
  <!-- Header -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;"
    class="flex items-center justify-between">
    <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">account_balance</mat-icon>
      {{ data.type === "UPDATE" ? "Actualizar cuenta de trabajo" : "Registrar cuenta de trabajo" }}
    </h2>
    <button type="button" (click)="onNoClick()"
      style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="p-6">
    <form *ngIf="formCuenta" [formGroup]="formCuenta" class="space-y-4">
      <!-- País -->
      <mat-form-field appearance="outline" class="modern-field w-full">
        <mat-label>País</mat-label>
        <mat-select required formControlName="pais" (selectionChange)="getBanks()">
          <mat-option>Seleccione país</mat-option>
          <mat-option *ngFor="let pais of paisesActivos" [value]="pais.codigoPais">
            {{ pais.nombre | titlecase }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Nombre + Apellidos -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Nombre</mat-label>
          <input type="text" matInput formControlName="nombre" placeholder="Ingresa tu nombre">
        </mat-form-field>
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Apellidos</mat-label>
          <input type="text" matInput formControlName="apellidos" placeholder="Ingresa tu apellido">
        </mat-form-field>
      </div>

      <!-- Tipo documento + Numero ID -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Tipo documento</mat-label>
          <mat-select required formControlName="tipoID">
            <mat-option>Tipo documento</mat-option>
            <mat-option *ngFor="let tipo of tiposID" [value]="tipo">{{ tipo }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Número identificación</mat-label>
          <input type="text" matInput formControlName="numeroID" placeholder="Ingresa tu documento">
        </mat-form-field>
      </div>

      <!-- Banco + Código -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Banco</mat-label>
          <mat-select required formControlName="banco">
            <mat-option>Seleccione el banco</mat-option>
            <mat-option *ngFor="let banco of bancos" [value]="banco">
              {{ banco.nombre | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Código</mat-label>
          <input type="text" matInput [disabled]="true" [value]="formCuenta.get('banco')?.value?.codigoBanco ?? ''">
        </mat-form-field>
      </div>

      <!-- Tipo cuenta + Numero cuenta -->
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Tipo de cuenta</mat-label>
          <mat-select required formControlName="tipoCuenta">
            <mat-option>Tipo de cuenta</mat-option>
            <mat-option *ngFor="let tipo of tiposCuentas" [value]="tipo.tipoCuentaID">
              {{ tipo.nombre | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="modern-field sm:col-span-2">
          <mat-label>Número de cuenta</mat-label>
          <input type="text" matInput formControlName="numeroCuenta" placeholder="Ej. 00000 0000 00000 00000">
          <mat-error *ngIf="formCuenta.get('numeroCuenta')?.invalid && (formCuenta.get('numeroCuenta')?.dirty || formCuenta.get('numeroCuenta')?.touched)">
            La cuenta no debe tener más de 20 dígitos
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Botón guardar -->
      <div class="flex justify-center pt-2">
        <button type="button" (click)="guardarCuentaTrabajo()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
          Guardar
        </button>
      </div>
    </form>
  </div>
</div>
